import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import { useToast } from "../Components/toast/ToastProvider";
import { getAllVendors } from "../Service/VendorService";
import CollapseCard from "../Components/CollapseCard";
import { Button, Table } from "react-bootstrap";
import OwnerPaymentFilter from "../Components/OwnerPaymentFilter";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "react-feather";
import { formatDate } from "../config/function";
import { getBillsByFilter } from "../Service/BillService";
import { getAllVehicles } from "../Service/VehicleService";

const OwnerPayment = () => {
  const [vendor, setVendor] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [filtered, setFiltered] = useState({
    date: "",
  });
  const [filteredList, setFilteredList] = useState([]);
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchVendors();
    fetchVehicles();
  }, []);

  const fetchVendors = async () => {
    try {
      const res = await getAllVendors();
      setVendor(res.data || []);
    } catch (err) {
      toast(err.message || "Failed to fetch vendors", "ERROR");
    }
  };

  const fetchVehicles = async () => {
    try {
      const res = await getAllVehicles();
      setVehicles(res.data || []);
    } catch (err) {
      toast(err.message || "Failed to fetch Vehicles", "ERROR");
    }
  };

  const handleFilterChange = (name, value) => {
    setFiltered((prev) => ({ ...prev, [name]: value }));
  };

  const handleFind = async () => {
    if (!filtered.date) {
      toast("Please select date", "ERROR");
      return;
    }
    setLoading(true);
    try {
      const res = await getBillsByFilter({
        date: filtered.date,
        status: "process",
      });

      const data = Array.isArray(res?.data?.bill) ? res.data.bill : [];

      if (data.length === 0) {
        toast("No records found", "ERROR");
      }
      const groupedData = Object.values(
        data.reduce((acc, item) => {
          const valued = item.vendor_id;
          if (!acc[valued]) {
            acc[valued] = {
              vendor_id: item.vendor_id,
              payable_amount: 0,
              trip_count: 0,
            };
          }
          acc[valued].payable_amount += parseFloat(item.payable_amount || 0);
          acc[valued].trip_count += Number(item.trip_count || 0);
          return acc;
        }, {}),
      );
      setTimeout(() => {
        setFilteredList(groupedData);
        setLoading(false);
      }, 1500);
    } catch (err) {
      toast(err.message || "Failed to fetch Owner Payments", "ERROR");
      setFilteredList([]);
    }
  };

  const handleReset = () => {
    setFiltered({ date: "" });
    setFilteredList([]);
  };

  const addPDFHeader = (doc, pageWidth) => {
    const logo = new Image();
    logo.src = "/img/asa_logo.png";

    const logoWidth = 18;
    const logoHeight = 18;
    const spacing = 5;

    const headerText = "ASA Transport";
    const subHeaderText = "Mannargudi";

    const headerWidth = doc.getTextWidth(headerText);
    const subHeaderWidth = doc.getTextWidth(subHeaderText);
    const totalWidth =
      logoWidth + spacing + Math.max(headerWidth, subHeaderWidth);
    const startX = (pageWidth - totalWidth) / 2;

    try {
      doc.addImage(logo, "PNG", startX, 8, logoWidth, logoHeight);
    } catch (e) {
      console.warn("Logo load skipped (small size optimization)");
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(headerText, startX + logoWidth + spacing, 14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(subHeaderText, startX + logoWidth + spacing, 20);
  };
  const generateTablePdf = () => {
    if (filteredList.length === 0) {
      toast("No Payments to export", "ERROR");
    }
    const capitalize = (str) => {
      if (!str) return "N/A";
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };
    const today = new Date();
    const currentDate = formatDate(today);

    const safeFixed = (value) => {
      let num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    };

    const doc = new jsPDF({ orientation: "potrait", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    addPDFHeader(doc, pageWidth);

    doc.setFontSize(13);
    doc.setFont("helvetica", "bold");
    doc.text("Owner Payment List", pageWidth / 2, 35, { align: "center" });

    doc.setFontSize(10);
    doc.text(`Date: ${currentDate}`, 14, 42);

    const tableColumn = ["S.No", "Vendor Name", "Trip Count", "Payable Amount"];

    const tableRows = filteredList.map((pay, index) => {
      const vendorName = vendor.find((v) => v.id === pay.vendor_id);

      return [
        index + 1,
        capitalize(vendorName?.name) || "N/A",
        pay.trip_count,
        safeFixed(pay.payable_amount) || "0.00",
      ];
    });
    autoTable(doc, {
      startY: 50,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 2,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: "bold",
      },
    });
    const pdfOutput = doc.output("arraybuffer");
    const fileSizeKB = pdfOutput.byteLength / 1024;
    doc.save(`Owner-Payment-${currentDate}.pdf`);
  };
  return (
    <>
      <Main>
        <PageContainer>
          <CollapseCard title="Owner Payment Filter ">
            <OwnerPaymentFilter
              filtered={filtered}
              vehicles={vehicles}
              handleFilterChange={handleFilterChange}
              handleFind={handleFind}
              handleReset={handleReset}
              loading={loading}
            />
          </CollapseCard>
          <CollapseCard title="Owner Payment List">
            <Table size="sm">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Vendor Name</th>
                  <th>Trip Count</th>
                  <th>Payable Amount</th>
                </tr>
              </thead>
              <tbody>
                {filteredList.map((fill, index) => {
                  console.log("fil", fill);

                  const vendors =
                    vendor.find((v) => v.id === fill.vendor_id)?.name || "";
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{vendors}</td>
                      <td>{fill.trip_count}</td>
                      <td>{fill.payable_amount.toFixed(2)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CollapseCard>
          <div className="d-flex justify-content-end mb-2 mt-2">
            <Button variant="success" size="sm" onClick={generateTablePdf}>
              <Download />
              Download PDF
            </Button>
          </div>
        </PageContainer>
      </Main>
    </>
  );
};

export default OwnerPayment;
